import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "biz-gubun-fullscreen"
}
const _hoisted_2 = { class: "fullscreen-content" }
const _hoisted_3 = { class: "select-card" }
const _hoisted_4 = { class: "select-icon" }
const _hoisted_5 = { class: "facility-name-title" }
const _hoisted_6 = { class: "biz-gubun-options" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "biz-name" }
const _hoisted_9 = {
  key: 1,
  class: "member-detail-layout"
}
const _hoisted_10 = { class: "sidebar-header" }
const _hoisted_11 = {
  key: 0,
  class: "logo-text"
}
const _hoisted_12 = { class: "sidebar-nav" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "nav-icon" }
const _hoisted_15 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_16 = {
  key: 1,
  class: "nav-badge"
}
const _hoisted_17 = {
  key: 0,
  class: "nav-page-tabs"
}
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "nav-icon" }
const _hoisted_21 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_22 = {
  key: 1,
  class: "nav-admin-badge"
}
const _hoisted_23 = {
  key: 0,
  class: "nav-children"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "nav-icon" }
const _hoisted_26 = { class: "nav-label" }
const _hoisted_27 = {
  key: 0,
  class: "nav-page-tabs"
}
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = { class: "sidebar-footer" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "detail-header" }
const _hoisted_33 = { class: "header-left" }
const _hoisted_34 = { class: "breadcrumb" }
const _hoisted_35 = {
  key: 1,
  class: "breadcrumb-item current"
}
const _hoisted_36 = { class: "facility-info" }
const _hoisted_37 = { class: "facility-name" }
const _hoisted_38 = { class: "biz-gubun-selector" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "header-right" }
const _hoisted_41 = {
  key: 0,
  class: "facility-code"
}
const _hoisted_42 = { class: "code-value" }
const _hoisted_43 = { class: "detail-content" }
const _hoisted_44 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_45 = { class: "loading-spinner" }
const _hoisted_46 = {
  key: 2,
  class: "error-state"
}
const _hoisted_47 = { class: "error-icon" }
const _hoisted_48 = {
  key: 3,
  class: "error-state"
}
const _hoisted_49 = { class: "error-icon" }
const _hoisted_50 = { class: "confirm-title-text" }

import { ref, onMounted, computed, provide, watch } from 'vue';
import { BUDGET_LEAVE_KEY, type BudgetLeaveApi } from '@/composables/budgetLeave';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { memberApi } from '@/services/api';
import { createMemberYearMonthState, MEMBER_YEAR_MONTH_KEY } from '@/composables/useMemberYearMonth';
import { createPageTabNav, PAGE_TAB_NAV_KEY } from '@/composables/usePageTabNav';

interface NavMenuItem {
  key: string;
  title: string;
  icon: string;
  routeName?: string;
  badge?: string | number;
  adminOnly?: boolean;
  /** SUPER_ADMIN(role_level ≥ 100) 전용 */
  superAdminOnly?: boolean;
  /** 최소 role_level (예: 관리자 60+) */
  minRole?: number;
  /** 임금/회계 담당 메뉴 분리 */
  assigneeType?: 'WAGE' | 'ACCOUNT' | 'COMMON';
  children?: NavMenuItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDetailLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();

// 현재 사용자 정보 (권한 체크용)
const userOrgCode = computed(() => store.getters.orgCode);
const userRoleLevel = computed(() => store.getters.actualRoleLevel ?? store.getters.roleLevel);
const currentUser = computed(() => store.getters.currentUser);

// 관리자 전용 메뉴용 (ADMIN+ role_level >= 90) — 매니저(60)는 자료요청 등 제외
const isAdmin = computed(() => (userRoleLevel.value || 0) >= 90);
/** 최고관리자(SUPER_ADMIN, role_level 100) */
const isSuperAdmin = computed(() => (userRoleLevel.value || 0) >= 100);

// 팝업 모드 vs 멤버 로그인 모드 판별
// route.meta.isPopup이 있으면 팝업 모드, 없으면 멤버 로그인 모드
const isPopupMode = computed(() => {
  return route.meta.isPopup === true;
});

// 멤버 로그인 모드: JWT idx = m_code (구 세션은 m_idx 숫자일 수 있음 → API에서 호환 조회)
const memberCodeForLogin = computed(() => {
  if (isPopupMode.value) return null;
  const user = currentUser.value;
  if (!user || user.userType !== 'member') return null;
  if (user.idx != null && String(user.idx).trim()) return String(user.idx);
  return null;
});

const resolvedMemberCode = computed(
  () => (route.params.memberCode as string) || memberCodeForLogin.value || ''
);

const loading = ref(true);
const memberData = ref<any>(null);
const accessDenied = ref(false);
const bizGubunColorMap = ref<Record<string, string>>({});

// 사업구분 관련
const selectedBizGubun = ref<string>('');
const changeBizGubunDialog = ref(false);
const pendingBizGubun = ref<string>('');
/** 방문요양·방문목욕 (임금설정 홈/시설 라우트 분기) */
const isHomeCareBiz = computed(
  () => selectedBizGubun.value === '방문요양' || selectedBizGubun.value === '방문목욕'
);

// 회계관리 라우트 — 방문요양/목욕/간호도 사업구분별로 분리 선택
const ACCOUNTING_ROUTE_NAMES = new Set([
  'memberBudgetRevision',
  'memberDetailBudgetRevision',
  'memberBankbook',
  'memberDetailBankbook',
  'memberBankbookTest',
  'memberDetailBankbookTest',
  'memberClosingHistory',
  'memberDetailClosingHistory',
]);

const isAccountingRoute = computed(() => {
  const name = route.name;
  return typeof name === 'string' && ACCOUNTING_ROUTE_NAMES.has(name);
});

// 사업구분 목록 (콤마로 구분된 경우 분리)
const bizGubunList = computed(() => {
  const raw = memberData.value?.m_biz_gubun;
  if (!raw) return [];
  return raw.split(',').map((s: string) => s.trim()).filter(Boolean);
});

// 방문 계열 사업구분만 있는지 확인 (방문요양, 방문목욕, 방문간호)
const isHomeCareBizOnly = computed(() => {
  const list = bizGubunList.value;
  if (list.length === 0) return false;
  return list.every((biz: string) => biz.startsWith('방문'));
});

// 임금관리: 방문 계열 통합(첫 항목) / 회계관리: 사업구분 개별 선택
const mergeHomeCareBizGubun = computed(() => isHomeCareBizOnly.value && !isAccountingRoute.value);

// 다중 사업구분이고 아직 선택되지 않은 경우 (임금·방문 통합 시 제외)
const needsBizGubunSelection = computed(() => {
  if (mergeHomeCareBizGubun.value) return false;
  return bizGubunList.value.length > 1 && !selectedBizGubun.value;
});

// 사업구분 선택 (초기 선택 또는 변경 요청)
const selectBizGubun = (biz: string) => {
  // 이미 선택된 사업구분과 같으면 무시
  if (selectedBizGubun.value === biz) return;
  
  // 임금·방문 통합 모드에서는 변경 불가 (첫 번째 사업구분 유지)
  if (mergeHomeCareBizGubun.value && selectedBizGubun.value) return;
  
  const memberCode = route.params.memberCode as string || memberCodeForLogin.value;
  
  // 아직 선택된 사업구분이 없으면 바로 선택 (초기 선택)
  if (!selectedBizGubun.value) {
    selectedBizGubun.value = biz;
    // sessionStorage에 저장
    if (memberCode) {
      sessionStorage.setItem(`bizGubun_${memberCode}`, biz);
    }
    return;
  }
  
  // 이미 선택된 사업구분이 있으면 변경 확인 다이얼로그 표시
  pendingBizGubun.value = biz;
  changeBizGubunDialog.value = true;
};

// 사업구분 변경 취소
const cancelBizGubunChange = () => {
  pendingBizGubun.value = '';
  changeBizGubunDialog.value = false;
};

// 사업구분 변경 확인 → 적절한 페이지로 이동
const confirmBizGubunChange = async () => {
  changeBizGubunDialog.value = false;
  if (!(await confirmBudgetLeave())) {
    cancelBizGubunChange();
    return;
  }
  const memberCode = route.params.memberCode as string || memberCodeForLogin.value;
  const newBizGubun = pendingBizGubun.value;
  
  // sessionStorage에 선택한 사업구분 저장
  if (memberCode) {
    sessionStorage.setItem(`bizGubun_${memberCode}`, newBizGubun);
  }
  
  budgetLeave.value?.allowNextUnload();
  window.location.reload();
};

// 사이드바 상태
const sidebarCollapsed = ref(false);

// 네비게이션 메뉴 아이템
const baseNavMenuItems: NavMenuItem[] = [
  { key: 'facility-info', title: '시설정보', icon: 'mdi-view-dashboard-outline', routeName: 'memberDetailInfo', assigneeType: 'COMMON' },
  { 
    key: 'request-group', 
    title: '자료요청', 
    icon: 'mdi-cloud-download-outline',
    adminOnly: true,
    badge: '관리자전용',
    assigneeType: 'COMMON',
    children: [
      { key: 'request-ltcs', title: '롱텀케어', icon: 'mdi-file-document-check-outline', routeName: 'memberDetailRequestLtcs', assigneeType: 'COMMON' },
      { key: 'request-ces', title: '희망이음', icon: 'mdi-file-document-edit-outline', routeName: 'memberDetailRequestCes', assigneeType: 'COMMON' }
    ]
  },
  {
    key: 'wage-group',
    title: '임금관리',
    icon: 'mdi-cash-multiple',
    assigneeType: 'WAGE',
    children: [
      { key: 'wage-hr', title: '인사관리', icon: 'mdi-account-group', routeName: 'memberDetailWageHr', assigneeType: 'WAGE' },
      { key: 'wage-monthly-setting', title: '임금설정', icon: 'mdi-calendar-month', routeName: 'memberDetailWageMonthlySettingFacility', assigneeType: 'WAGE' },
    ]
  },
  { 
    key: 'accounting-group', 
    title: '회계관리', 
    icon: 'mdi-book-open-variant',
    assigneeType: 'ACCOUNT',
    children: [
      { key: 'budget-revision', title: '예산추경관리', icon: 'mdi-file-document-plus-outline', routeName: 'memberDetailBudgetRevision', assigneeType: 'ACCOUNT' },
      { key: 'bankbook', title: '월별통장내역', icon: 'mdi-calendar-month', routeName: 'memberDetailBankbook', assigneeType: 'ACCOUNT' },
      { key: 'closing-history', title: '마감요청내역', icon: 'mdi-clipboard-check-outline', routeName: 'memberDetailClosingHistory', assigneeType: 'ACCOUNT' },
      { key: 'accounting-reports', title: '회계보고서류', icon: 'mdi-file-chart-outline', routeName: 'memberDetailAccountingReports', assigneeType: 'ACCOUNT' }
    ]
  }
];

/** API access: 관리자90+ / 멤버본인 / 임금·회계 배정 */
const memberAccess = computed(() => {
  const a = memberData.value?.access;
  if (!a) {
    return { isAdmin: false, hasWage: false, hasAccount: false, hasAny: false, isMemberSelf: false };
  }
  return {
    isAdmin: !!a.isAdmin,
    hasWage: !!a.hasWage,
    hasAccount: !!a.hasAccount,
    hasAny: !!a.hasAny,
    isMemberSelf: !!a.isMemberSelf,
  };
});

const canShowNavItem = (item: NavMenuItem): boolean => {
  if (item.adminOnly && !isAdmin.value) return false;
  if (item.superAdminOnly && !isSuperAdmin.value) return false;
  if (item.minRole != null && (userRoleLevel.value || 0) < item.minRole) return false;

  // 관리자(90+): 자료요청만 adminOnly로 제한, 임금·회계는 항상 표시
  if (isAdmin.value) return true;

  const acc = memberAccess.value;
  if (!memberData.value?.access) return true;
  if (acc.isAdmin || acc.isMemberSelf) return true;
  if (item.assigneeType === 'WAGE') return acc.hasWage;
  if (item.assigneeType === 'ACCOUNT') return acc.hasAccount;
  return acc.hasAny;
};

// 사용자 권한에 따라 필터링된 메뉴 아이템
const navMenuItems = computed(() => {
  return baseNavMenuItems
    .filter((item) => canShowNavItem(item))
    .map((item) => {
      if (!item.children?.length) return item;
      return {
        ...item,
        children: item.children.filter((child) => {
          if (!canShowNavItem(child)) return false;
          return true;
        }),
      };
    });
});

// 라우트 이름 변환 (팝업 모드 vs 멤버 로그인 모드)
const getRouteName = (baseRouteName: string) => {
  if (isPopupMode.value) {
    return baseRouteName; // memberDetailInfo, etc.
  }
  // 멤버 로그인 모드: memberDetail 제거
  return baseRouteName.replace('memberDetail', 'member'); // memberInfo, etc.
};

// 펼쳐진 메뉴 그룹
const expandedMenus = ref<string[]>([]);

/** 임금설정 — 방문요양(Home) / 시설(Facility) 라우트 모두 동일 메뉴 */
const isWageMonthlySettingRoute = (routeName: string) => {
  const home = getRouteName('memberDetailWageMonthlySettingHome');
  const facility = getRouteName('memberDetailWageMonthlySettingFacility');
  return routeName === home || routeName === facility;
};

const isNavChildActive = (child: NavMenuItem, currentRouteName: string) => {
  if (child.key === 'wage-monthly-setting') {
    return isWageMonthlySettingRoute(currentRouteName);
  }
  if (!child.routeName) return false;
  return currentRouteName === getRouteName(child.routeName);
};

// 현재 경로에 해당하는 부모 메뉴 그룹 자동 펼치기
const initExpandedMenus = () => {
  const currentRouteName = String(route.name);
  for (const menu of navMenuItems.value) {
    if (menu.children) {
      const hasActiveChild = menu.children.some((child) =>
        isNavChildActive(child, currentRouteName)
      );
      if (hasActiveChild && !expandedMenus.value.includes(menu.key)) {
        expandedMenus.value.push(menu.key);
      }
    }
  }
};

// 현재 활성 메뉴 확인
const isActiveMenu = (menuKey: string) => {
  const currentRouteName = String(route.name);

  if (menuKey === 'wage-monthly-setting') {
    return isWageMonthlySettingRoute(currentRouteName);
  }

  // 1단계 메뉴 확인
  const item = navMenuItems.value.find(m => m.key === menuKey);
  if (item?.routeName) {
    // 팝업 모드: 정확히 일치, 멤버 로그인 모드: memberDetail 제거하고 비교
    const expectedRouteName = getRouteName(item.routeName);
    return currentRouteName === expectedRouteName;
  }
  // 2단계 메뉴 확인
  for (const menu of navMenuItems.value) {
    if (menu.children) {
      const child = menu.children.find(c => c.key === menuKey);
      if (child) {
        return isNavChildActive(child, currentRouteName);
      }
    }
  }
  return false;
};

// 메뉴 그룹 펼침/접기
const toggleMenuGroup = (menuKey: string) => {
  // collapsed 상태에서 그룹 메뉴 클릭 시 사이드바 펼치기
  if (sidebarCollapsed.value) {
    sidebarCollapsed.value = false;
    // 해당 메뉴 그룹도 펼치기
    if (!expandedMenus.value.includes(menuKey)) {
      expandedMenus.value.push(menuKey);
    }
    return;
  }
  
  const idx = expandedMenus.value.indexOf(menuKey);
  if (idx >= 0) {
    expandedMenus.value.splice(idx, 1);
  } else {
    expandedMenus.value.push(menuKey);
  }
};

// 메뉴 그룹 펼침 여부
const isMenuExpanded = (menuKey: string) => {
  return expandedMenus.value.includes(menuKey);
};

// 메뉴 이동
const navigateToMenu = (menuKey: string) => {
  const memberCode = route.params.memberCode as string;

  // 월별임금설정 메뉴 (방문요양/목욕 → 홈 임금설정, 그 외 → 시설)
  if (menuKey === 'wage-monthly-setting') {
    const wageRouteName = isHomeCareBiz.value
      ? getRouteName('memberDetailWageMonthlySettingHome')
      : getRouteName('memberDetailWageMonthlySettingFacility');
    if (isPopupMode.value) {
      router.push({ name: wageRouteName, params: { memberCode } });
    } else {
      router.push({ name: wageRouteName });
    }
    return;
  }

  // 1단계 메뉴 확인
  const item = navMenuItems.value.find(m => m.key === menuKey);
  if (item?.routeName) {
    const routeName = getRouteName(item.routeName);
    if (isPopupMode.value) {
      router.push({ name: routeName, params: { memberCode } });
    } else {
      router.push({ name: routeName });
    }
    return;
  }
  
  // 2단계 메뉴 확인
  for (const menu of navMenuItems.value) {
    if (menu.children) {
      const child = menu.children.find(c => c.key === menuKey);
      if (child?.routeName) {
        const routeName = getRouteName(child.routeName);
        if (isPopupMode.value) {
          router.push({ name: routeName, params: { memberCode } });
        } else {
          router.push({ name: routeName });
        }
        return;
      }
    }
  }
};

// 사업구분 색상
const getBizGubunColor = (bizGubun: string) => {
  return bizGubunColorMap.value[bizGubun] || '#607d8b';
};

// 멤버 데이터 로드
const loadMemberData = async (memberCode: string) => {
  loading.value = true;
  memberData.value = null;
  accessDenied.value = false;
  
  try {
    const params: Record<string, any> = {};
    if (store.getters.isImpersonating) {
      params.roleLevel = store.getters.roleLevel;
      params.userIdx = currentUser.value?.idx;
    }
    const memberRes = await memberApi.getById(memberCode, params);
    memberData.value = memberRes.data?.data || null;
    
    const bizRes = await memberApi.getBizGubunList();
    if (bizRes.data?.data) {
      const colorMap: Record<string, string> = {};
      bizRes.data.data.forEach((item: any) => {
        colorMap[item.bg_name] = item.bg_color;
      });
      bizGubunColorMap.value = colorMap;
    }
    
    // 사업구분 자동 선택 로직
    if (memberData.value?.m_biz_gubun) {
      const list = memberData.value.m_biz_gubun.split(',').map((s: string) => s.trim()).filter(Boolean);
      const allHomeCare = list.every((biz: string) => biz.startsWith('방문'));
      const routeName = route.name;
      const onAccounting =
        typeof routeName === 'string' && ACCOUNTING_ROUTE_NAMES.has(routeName);

      if (list.length === 1) {
        selectedBizGubun.value = list[0];
      } else if (allHomeCare && !onAccounting) {
        // 임금 등: 방문 전용 다중 → 첫 번째만 (청구 API는 별도 통합)
        selectedBizGubun.value = list[0];
      } else if (list.length > 1) {
        // 회계관리·시설 혼합: sessionStorage에서 이전 선택값 복원
        const savedBizGubun = sessionStorage.getItem(`bizGubun_${memberCode}`);
        if (savedBizGubun && list.includes(savedBizGubun)) {
          selectedBizGubun.value = savedBizGubun;
        } else {
          selectedBizGubun.value = list[0];
        }
      }
    }
    
    if (memberData.value?.m_name) {
      document.title = `${memberData.value.m_name} - ${route.meta.title || '시설 상세정보'}`;
    }
  } catch (error: any) {
    console.error('멤버 정보 조회 오류:', error);
    if (error.response?.status === 403) {
      accessDenied.value = true;
    }
  } finally {
    loading.value = false;
  }
};

const budgetLeave = ref<BudgetLeaveApi | null>(null);
provide(BUDGET_LEAVE_KEY, budgetLeave);

async function confirmBudgetLeave(): Promise<boolean> {
  if (!budgetLeave.value) return true;
  return budgetLeave.value.confirmDiscard();
}

// 팝업 닫기
const closePopup = async () => {
  if (!(await confirmBudgetLeave())) return;
  budgetLeave.value?.allowNextUnload();
  window.close();
};

// 로그아웃 (멤버 로그인 모드)
const handleLogout = async () => {
  if (!(await confirmBudgetLeave())) return;
  budgetLeave.value?.allowNextUnload();
  store.dispatch('logout');
  window.location.href = '/login';
};

// 시설별 연월 (sessionStorage 연동 — m_code 기준)
const activeMemberCode = computed(() => {
  if (memberData.value?.m_code) return String(memberData.value.m_code);
  return resolvedMemberCode.value;
});

const memberYearMonth = createMemberYearMonthState(activeMemberCode);

// 하위 컴포넌트에 데이터 제공
provide('memberData', memberData);
provide('bizGubunColorMap', bizGubunColorMap);
provide('selectedBizGubun', selectedBizGubun);
provide('loading', loading);
provide(MEMBER_YEAR_MONTH_KEY, memberYearMonth);

const pageTabNav = createPageTabNav();
provide(PAGE_TAB_NAV_KEY, pageTabNav);
const pageTabs = computed(() => pageTabNav.tabs.value);
const pageTabActive = computed(() => pageTabNav.activeKey.value);
const selectPageTab = (key: string) => pageTabNav.select(key);
provide('memberSelectedYear', memberYearMonth.selectedYear);
provide('memberSelectedMonth', memberYearMonth.selectedMonth);

// 라우트·로그인 멤버코드 변경 시 재조회
watch(
  resolvedMemberCode,
  (code) => {
    if (code) {
      loadMemberData(code);
    } else if (!isPopupMode.value && !currentUser.value) {
      loading.value = false;
    } else if (!code) {
      loading.value = false;
      memberData.value = null;
    }
  },
  { immediate: true }
);

watch(currentUser, (user) => {
  if (!isPopupMode.value && user?.userType === 'member' && resolvedMemberCode.value) {
    loadMemberData(resolvedMemberCode.value);
  }
});

/** 담당 권한 없는 메뉴로 직접 진입 시 시설정보로 이동 */
const enforceAssigneeRouteAccess = () => {
  if (!memberData.value?.access || accessDenied.value) return;
  const acc = memberAccess.value;
  // 관리자 JWT(90+)·API access·멤버 본인 — 임금/회계 진입 허용
  if (isAdmin.value || acc.isAdmin || acc.isMemberSelf) return;

  const name = String(route.name || '');
  const isAccounting = ACCOUNTING_ROUTE_NAMES.has(name);
  const isWage =
    name.includes('Wage') ||
    name.includes('wage') ||
    name.includes('Beneficiary') ||
    name.includes('beneficiary');

  if (isAccounting && !acc.hasAccount) {
    router.replace({ name: getRouteName('memberDetailInfo'), params: route.params });
    return;
  }
  if (isWage && !acc.hasWage) {
    router.replace({ name: getRouteName('memberDetailInfo'), params: route.params });
  }
};

// 라우트 변경 시 메뉴 그룹 펼치기
onMounted(() => {
  initExpandedMenus();
});

watch(() => route.name, () => {
  initExpandedMenus();
  enforceAssigneeRouteAccess();
});

watch(memberAccess, () => {
  enforceAssigneeRouteAccess();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (!loading.value && memberData.value && needsBizGubunSelection.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "close-fullscreen-btn",
              onClick: closePopup,
              title: "닫기"
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "64",
                color: "#1e3a5f"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-office-building-cog-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("h1", _hoisted_5, _toDisplayString(memberData.value.m_name), 1),
            _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "select-title" }, "사업구분을 선택해주세요", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "select-desc" }, [
              _createTextVNode(" 이 시설은 여러 사업을 운영하고 있습니다."),
              _createElementVNode("br"),
              _createTextVNode(" 관리할 사업구분을 선택하면 해당 사업의 데이터만 표시됩니다. ")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizGubunList.value, (biz) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: biz,
                  class: "biz-option-btn",
                  style: _normalizeStyle({ 
              '--biz-color': getBizGubunColor(biz),
              '--biz-color-light': getBizGubunColor(biz) + '15'
            }),
                  onClick: ($event: any) => (selectBizGubun(biz))
                }, [
                  _createElementVNode("span", {
                    class: "biz-color-dot",
                    style: _normalizeStyle({ backgroundColor: getBizGubunColor(biz) })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(biz), 1),
                  _createVNode(_component_v_icon, {
                    size: "18",
                    class: "biz-arrow"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ], 12, _hoisted_7))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("aside", {
          class: _normalizeClass(["detail-sidebar", { collapsed: sidebarCollapsed.value }])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "logo-area",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarCollapsed.value = !sidebarCollapsed.value))
            }, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-domain", -1)
                ]))]),
                _: 1
              }),
              (!sidebarCollapsed.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "CAION"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "collapse-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sidebarCollapsed.value = !sidebarCollapsed.value))
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "rgba(255,255,255,0.7)"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(sidebarCollapsed.value ? 'mdi-chevron-right' : 'mdi-chevron-left'), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("nav", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navMenuItems.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.key
              }, [
                (!item.children)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-item", { active: isActiveMenu(item.key) }]),
                        onClick: ($event: any) => (navigateToMenu(item.key))
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_v_icon, { size: "20" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.icon), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        (!sidebarCollapsed.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.title), 1))
                          : _createCommentVNode("", true),
                        (!sidebarCollapsed.value && item.badge)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.badge), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_13),
                      (!sidebarCollapsed.value && isActiveMenu(item.key) && pageTabs.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageTabs.value, (tab) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: tab.key || tab.title,
                                type: "button",
                                class: _normalizeClass(["nav-page-tab", { active: pageTabActive.value === tab.key }]),
                                disabled: tab.disabled,
                                onClick: _withModifiers(($event: any) => (selectPageTab(tab.key)), ["stop"])
                              }, [
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "nav-page-tab-mark" }, "-", -1)),
                                _createTextVNode(_toDisplayString(tab.title), 1)
                              ], 10, _hoisted_18))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["nav-group", { expanded: isMenuExpanded(item.key) }])
                    }, [
                      _createElementVNode("a", {
                        class: "nav-item nav-group-header",
                        onClick: ($event: any) => (toggleMenuGroup(item.key))
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_v_icon, { size: "20" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.icon), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        (!sidebarCollapsed.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.title), 1))
                          : _createCommentVNode("", true),
                        (!sidebarCollapsed.value && item.badge)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.badge), 1))
                          : _createCommentVNode("", true),
                        (!sidebarCollapsed.value)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 2,
                              size: "16",
                              class: "nav-arrow"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(isMenuExpanded(item.key) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_19),
                      (!sidebarCollapsed.value && isMenuExpanded(item.key))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: child.key
                              }, [
                                _createElementVNode("a", {
                                  class: _normalizeClass(["nav-item nav-child", { active: isActiveMenu(child.key) }]),
                                  onClick: ($event: any) => (navigateToMenu(child.key))
                                }, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(child.icon), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(child.title), 1)
                                ], 10, _hoisted_24),
                                (isActiveMenu(child.key) && pageTabs.value.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageTabs.value, (tab) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: tab.key || tab.title,
                                          type: "button",
                                          class: _normalizeClass(["nav-page-tab", { active: pageTabActive.value === tab.key }]),
                                          disabled: tab.disabled,
                                          onClick: _withModifiers(($event: any) => (selectPageTab(tab.key)), ["stop"])
                                        }, [
                                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "nav-page-tab-mark" }, "-", -1)),
                                          _createTextVNode(_toDisplayString(tab.title), 1)
                                        ], 10, _hoisted_28))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_29, [
            (isPopupMode.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "close-btn",
                  onClick: closePopup
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  }),
                  (!sidebarCollapsed.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "닫기"))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "logout-btn",
                  onClick: handleLogout
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("mdi-logout", -1)
                    ]))]),
                    _: 1
                  }),
                  (!sidebarCollapsed.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "로그아웃"))
                    : _createCommentVNode("", true)
                ]))
          ])
        ], 2),
        _createElementVNode("main", {
          class: _normalizeClass(["detail-main", { 'sidebar-collapsed': sidebarCollapsed.value }])
        }, [
          _createElementVNode("header", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                (isPopupMode.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "breadcrumb-item" }, "고객관리", -1)),
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "#90a4ae"
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-chevron-right", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "breadcrumb-item current" }, "시설 상세", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_35, "내 시설"))
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("h1", _hoisted_37, _toDisplayString(memberData.value?.m_name || '시설 정보'), 1),
                _createElementVNode("div", _hoisted_38, [
                  (bizGubunList.value.length > 1 && !mergeHomeCareBizGubun.value)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(bizGubunList.value, (biz) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: biz,
                          class: _normalizeClass(["biz-chip", { selected: selectedBizGubun.value === biz }]),
                          style: _normalizeStyle({ 
                    backgroundColor: selectedBizGubun.value === biz ? getBizGubunColor(biz) : 'transparent',
                    borderColor: getBizGubunColor(biz),
                    color: selectedBizGubun.value === biz ? 'white' : getBizGubunColor(biz)
                  }),
                          onClick: ($event: any) => (selectBizGubun(biz))
                        }, _toDisplayString(biz), 15, _hoisted_39))
                      }), 128))
                    : (mergeHomeCareBizGubun.value && bizGubunList.value.length > 1)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(bizGubunList.value, (biz) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: biz,
                            class: "biz-chip selected",
                            style: _normalizeStyle({ backgroundColor: getBizGubunColor(biz) })
                          }, _toDisplayString(biz), 5))
                        }), 128))
                      : (bizGubunList.value.length === 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "biz-chip selected",
                            style: _normalizeStyle({ backgroundColor: getBizGubunColor(bizGubunList.value[0]) })
                          }, _toDisplayString(bizGubunList.value[0]), 5))
                        : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge status-badge", memberData.value?.m_status === 1 ? 'active' : 'inactive'])
                  }, _toDisplayString(memberData.value?.m_status === 1 ? '활성' : '비활성'), 3)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              (memberData.value?.m_longterm_code)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "code-label" }, "시설코드", -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(memberData.value.m_longterm_code), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "#1e3a5f",
                      size: "48",
                      width: "4"
                    })
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("p", { class: "loading-text" }, "데이터를 불러오는 중...", -1))
                ]))
              : (memberData.value)
                ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
                : (accessDenied.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_v_icon, {
                          size: "64",
                          color: "#c62828"
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode("mdi-shield-lock-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "error-title" }, "접근 권한이 없습니다", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("p", { class: "error-desc" }, "해당 시설의 임금/회계 담당으로 배정되지 않았습니다.", -1)),
                      _createElementVNode("button", {
                        class: "error-btn",
                        onClick: closePopup
                      }, "닫기")
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_v_icon, {
                          size: "64",
                          color: "#90a4ae"
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("mdi-file-search-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "error-title" }, "시설 정보를 찾을 수 없습니다", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("p", { class: "error-desc" }, "요청하신 시설 정보가 존재하지 않거나 삭제되었습니다.", -1))
                    ]))
          ])
        ], 2),
        _createVNode(_component_v_dialog, {
          modelValue: changeBizGubunDialog.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((changeBizGubunDialog).value = $event)),
          "max-width": "400",
          persistent: "",
          onKeydown: _withKeys(confirmBizGubunChange, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "confirm-dialog" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "confirm-title" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_50, [
                      _createVNode(_component_v_icon, {
                        class: "mr-2",
                        color: "#1e3a5f"
                      }, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode("mdi-swap-horizontal", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[25] || (_cache[25] = _createTextVNode(" 사업구분 변경 ", -1))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "confirm-close",
                      "aria-label": "닫기",
                      onClick: cancelBizGubunChange
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "confirm-text" }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(pendingBizGubun.value), 1),
                    _cache[27] || (_cache[27] = _createTextVNode(" 사업구분으로 변경하시겠습니까?", -1)),
                    _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "confirm-hint" }, "페이지가 새로고침됩니다.", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "confirm-actions" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      class: "btn-cancel",
                      onClick: cancelBizGubunChange
                    }, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode("취소", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      class: "btn-confirm",
                      onClick: confirmBizGubunChange
                    }, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("확인", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
}
}

})